<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="6"
      >
        <h1 class="green--text">
          <v-icon color="green" class="mb-1" left large>mdi-check-circle</v-icon>
          Thank You For Reviewing Our Recommendations
        </h1>

        <p class="mt-6">Your bicycle will now go to the workshop for work to be completed. We will send you an email confirming everything.</p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import HasBookingId from '@/mixins/HasBookingId'
import HasBikeId from '@/mixins/HasBikeId'
import HasPostcode from '@/mixins/HasPostcode'
import HasApiSignature from '@/mixins/HasApiSignature'

export default {
  name: 'Complete',

  mixins: [
    HasBookingId,
    HasBikeId,
    HasPostcode,
    HasApiSignature
  ]
}
</script>
